import { render, staticRenderFns } from "./SaleTerms.vue?vue&type=template&id=b4f1ff96&scoped=true&"
import script from "./SaleTerms.vue?vue&type=script&lang=js&"
export * from "./SaleTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f1ff96",
  null
  
)

export default component.exports